"use client";

import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/navigation";
import {
  clearAuthSession,
  fetchSessionUser,
  mightHaveAuthSession,
} from "@/lib/authClient";

const SESSION_POLL_MS = 5 * 60 * 1000;

export default function SessionChecker() {
  const router = useRouter();
  const pollRef = useRef<number | null>(null);
  const [sessionMarked, setSessionMarked] = useState(false);

  useEffect(() => {
    setSessionMarked(mightHaveAuthSession());

    const onAuthChanged = () => {
      setSessionMarked(mightHaveAuthSession());
    };

    window.addEventListener("auth:changed", onAuthChanged);
    return () => window.removeEventListener("auth:changed", onAuthChanged);
  }, []);

  useEffect(() => {
    if (!sessionMarked) return;

    const doLogout = () => {
      clearAuthSession(true);
      if (window.location.pathname !== "/area-riservata") {
        router.push("/area-riservata");
      }
    };

    const validate = async () => {
      const user = await fetchSessionUser({ clearStale: true });
      if (user) return;
      if (window.location.pathname === "/area-riservata") return;
      doLogout();
    };

    void validate();

    pollRef.current = window.setInterval(() => {
      void validate();
    }, SESSION_POLL_MS);

    const onStorage = (e: StorageEvent) => {
      if (e.key === "logout") doLogout();
    };
    const onAuthChanged = () => {
      if (mightHaveAuthSession()) return;
      if (window.location.pathname === "/area-riservata") return;
      doLogout();
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener("auth:changed", onAuthChanged);

    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("auth:changed", onAuthChanged);
    };
  }, [router, sessionMarked]);

  return null;
}
